<mat-card class="cardWithShadow theme-card">
    <mat-card-header>
        <mat-card-title class="m-b-0">
            Welcome,  {{ formatName(user) }}
        </mat-card-title>

        <mat-card-subtitle style="margin-top: 10px;">
            {{getRoleLabel(user?.role || 0)}}
        </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content class="b-t-1">

        <form class="m-t-0" [formGroup]="profileForm" (ngSubmit)="submit()">
            <div class="row">

                <!-- IMAGE -->
                <div class="col-12 d-flex justify-content-center m-b-30">
                    <div class="avatar-wrapper">
                        <div class="avatar-frame">
                            <img [src]="user?.image | filePath" alt="Profile picture" />
                        </div>
                        @if (isMe) {
                        <button mat-mini-fab color="primary" type="button"
                                class="avatar-edit" aria-label="Change picture"
                                (click)="editImage()">
                            <mat-icon>edit</mat-icon>
                        </button>
                        }
                    </div>
                </div>

                <!-- EMAIL -->
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <mat-label>Email</mat-label>
                    <mat-form-field appearance="outline" class="w-100">
                        <input matInput formControlName="email" [readonly]="!isMe" />
                        @if (f.email.hasError('required')) {
                        <mat-error>Email is required</mat-error>
                        }
                        @else if (f.email.hasError('email')) {
                        <mat-error>Invalid email</mat-error>
                        }
                    </mat-form-field>
                </div>

                <!-- FIRST NAME -->
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <mat-label>First Name</mat-label>
                    <mat-form-field appearance="outline" class="w-100">
                        <input matInput formControlName="firstName" [readonly]="!isMe" />
                        @if (f.firstName.hasError('required')) {
                        <mat-error>First name is required</mat-error>
                        }
                    </mat-form-field>
                </div>

                <!-- SECOND NAME -->
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <mat-label>Second Name</mat-label>
                    <mat-form-field appearance="outline" class="w-100">
                        <input matInput formControlName="secondName" [readonly]="!isMe" />
                    </mat-form-field>
                </div>

                <!-- GENDER -->
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <mat-label>Gender</mat-label>
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-select formControlName="gender" [disabled]="!isMe">
                            @for(option of genderList; track option.value) {
                            <mat-option [value]="option.value">{{ option.label }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- PHONE -->
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <mat-label>Phone Number</mat-label>
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-tel-input formControlName="phone" [preferredCountries]="['es']" format="national"
                            (countryChanged)="onPhoneCountryChange($event)" [enableSearch]="true"
                            [disabled]="!isMe"></mat-tel-input>

                        @if (f.phone.hasError('validatePhoneNumber')) {
                        <mat-error>Invalid phone number</mat-error>
                        }
                        @else if (f.phone.hasError('required')) {
                        <mat-error>Phone is required</mat-error>
                        }
                        @else if (f.phoneCountryIso.hasError('required')) {
                        <mat-error>Phone Country is required</mat-error>
                        }
                    </mat-form-field>
                </div>

                <!-- ADDRESS -->
                <div class="col-lg-8 col-md-12 col-sm-12">
                    <mat-label>Address</mat-label>
                    <mat-form-field appearance="outline" class="w-100">
                        <input matInput formControlName="address" />
                    </mat-form-field>
                </div>



                <!-- NATIONALITY -->
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <label style="padding: 0;">Nationality</label>
                    <ng-country-select #countrySelect [formControl]="f.nationality" [appearance]="'outline'"
                        [showRequiredErrorMessage]="false" class="w-100">
                    </ng-country-select>

                    @if (f.nationality.hasError('required') && f.nationality.touched) {
                    <mat-error>Nationality is required</mat-error>
                    }
                </div>

                @if(isInstructor){
                <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="activities$ | async as avm">
                     <mat-label>Activity</mat-label>
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-select formControlName="activityIds" multiple [disabled]="true">
                            @for(option of avm.activities; track option.value) {
                            <mat-option [value]="option.value">{{ option.label }}</mat-option>
                            }
                        </mat-select>
                        @if (f.activityIds.hasError('required')) {
                        <mat-error>Activity is <strong>required</strong></mat-error>
                        }
                        @if (avm.error) {
                        <mat-error>{{avm.error}}</mat-error>
                        }
                        @if (avm.loading) {
                        <mat-hint>Loading...</mat-hint>
                        }
                    </mat-form-field>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="languages$ | async as lvm">
                    <mat-label>Language</mat-label>
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-select formControlName="languageIds" multiple [disabled]="true">
                            @for(option of lvm.languages; track option.value) {
                            <mat-option [value]="option.value">{{ option.label }}</mat-option>
                            }
                        </mat-select>
                        @if (f.languageIds.hasError('required')) {
                        <mat-error>Language is <strong>required</strong></mat-error>
                        }
                        @if (lvm.error) {
                        <mat-error>{{lvm.error}}</mat-error>
                        }
                        @if (lvm.loading) {
                        <mat-hint>Loading...</mat-hint>
                        }
                    </mat-form-field>
                </div>
                }
            </div>

            @if (isMe) {
            <button mat-flat-button class="m-t-20" color="primary">
                Update Profile
            </button>
            }
        </form>

        <mat-divider></mat-divider>

        <!-- My Schools — visible only for instructors -->
        <div *ngIf="isInstructor" class="my-schools-section m-t-24">
          <h3 class="my-schools-title">My Schools</h3>
          <div *ngIf="mySchools.length === 0" class="my-schools-empty">No schools associated yet.</div>
          <div class="my-schools-list">
            <div *ngFor="let s of mySchools" class="school-chip">
              <mat-icon class="school-chip-icon">school</mat-icon>
              <span>{{ s.school?.name || s.school?.legalName || '—' }}</span>
            </div>
          </div>
        </div>

    </mat-card-content>
</mat-card>